import { render, staticRenderFns } from "./suppliersModal.vue?vue&type=template&id=0fca3f57&"
import script from "./suppliersModal.vue?vue&type=script&lang=js&"
export * from "./suppliersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports